// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-n_gZ","advertDetailParameterList__header":"c-n_ha","advertDetailParameterList__list":"c-n_hb"};